<template>
    <NodeBase :title="label" icon="⚡" color="#0891b2">
        <p class="text-gray-400 text-[10px] italic">Entry point — runs when {{ hint }}</p>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ data: Object });

const LABELS = {
    boot: 'Boot',
    online: 'Online',
    offline: 'Offline',
    idle_off: 'Idle Off',
    idle_short: 'Idle Short',
    idle_long: 'Idle Long',
};

const HINTS = {
    boot: 'device starts up',
    online: 'WiFi connects',
    offline: 'WiFi disconnects',
    idle_off: 'screen wakes from idle',
    idle_short: 'short idle starts',
    idle_long: 'long idle starts',
};

const label = computed(() => LABELS[props.data?.scriptName] ?? props.data?.scriptName ?? 'Trigger');
const hint = computed(() => HINTS[props.data?.scriptName] ?? props.data?.scriptName);
</script>
